module.exports = __webpack_public_path__ + "img/haowu@2x.4b5fbfc0.png";